// A troca de empresa avisa todos os dispositivos do usuário com o push
// ATUALIZADADOSUSUARIO, inclusive esta aba, que já recarrega os dados no próprio
// fluxo da troca. Cada troca leva um id que o servidor devolve no push: só o aviso
// da própria troca é ignorado; os de outras origens (app, outras abas) são
// atendidos. Os ids ficam só na memória da aba.
const MAX_TROCAS_LEMBRADAS = 20;
const trocasDestaAba = [];

export function novoIdTrocaEmpresa() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

export function registrarTrocaEmpresa(trocaId) {
  trocasDestaAba.push(trocaId);
  if (trocasDestaAba.length > MAX_TROCAS_LEMBRADAS) {
    trocasDestaAba.shift();
  }
}

// Troca que não terminou: o aviso dela volta a recarregar os dados.
export function descartarTrocaEmpresa(trocaId) {
  const index = trocasDestaAba.indexOf(trocaId);
  if (index >= 0) {
    trocasDestaAba.splice(index, 1);
  }
}

export function ehPushDaPropriaTroca(payload) {
  const trocaId = payload?.trocaId;
  return !!trocaId && trocasDestaAba.includes(trocaId);
}
